<p [ngClass]="{'doc-body-2': boldLabel}" [innerHTML]="label"></p>
<mat-hint>
    <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
</mat-hint>
<mat-radio-group class="optionsGroup" (change)="selectionChanged($event)">
    <!-- <mat-radio-button [value]="getValue(option)" [checked]="isChecked(option)" *ngFor="let option of options">
        {{getKey(option)}}
    </mat-radio-button> -->
</mat-radio-group>